import fetch from '@/api/fetch';

// 登录
export const login = req =>
  fetch({
    url: '/login',
    method: 'post',
    withCredentials: true,
    timeout: 60000,
    ...req,
  });
// 登出
export const logout = () =>
  fetch({
    method: 'post',
    data: {},
  });
// 修改密码
export const changePwd = req =>
  fetch({
    url: '/login/modifiyPwd',
    method: 'post',
    ...req,
  });
// 获取验证码
export const fetchVcode = req =>
  fetch({
    url: '/login/verifyCode',
    method: 'get',
    withCredentials: true,
    ...req,
  });
